
import styles from './styles.module.scss';
const Button = (props) => {

    const clickHandler = () => {
        if(props.click){
        props.click();
        }
        
    }
    
    return (
        <div onClick={clickHandler} className={`${styles['nc-button']} ${styles['nc-button--' + props.size]}`}>
             <div>
                {props.children}
            </div>
        </div>
    );
}


export default Button;